import { defaultTheme } from '@3plearning/react-components';

export default {
  ...defaultTheme.layout,
  borderRadius: '6px',
  spacing: 8
};



// WEBPACK FOOTER //
// ./themes/upf-theme/layout.js